<template>
    <!-- <img data-test-key="image-loader" class="_imgLoader" src="@/assets/images/loading.gif"/> -->
    <img data-test-key="image-loader" class="_imgLoader animate-spin w-20 h-20 border-[3px] border-l-transparent border-violet-500 rounded-full" />
</template>